import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/cn';

type Tag = 'h1' | 'h2' | 'h3' | 'p' | 'span' | 'div';

interface LineMaskProps extends HTMLAttributes<HTMLElement> {
  as?: Tag;
  /** One entry per visual line. Each is revealed by sliding up inside an overflow-hidden row. */
  lines: ReactNode[];
  lineClassName?: string;
}

export function LineMask({ as = 'p', lines, className, lineClassName, ...rest }: LineMaskProps) {
  const Component = as;
  return (
    <Component className={cn('line-mask', className)} {...rest}>
      {lines.map((line, i) => (
        <span key={i} className="lm-row">
          <span data-line className={lineClassName}>
            {line}
          </span>
        </span>
      ))}
    </Component>
  );
}
